import { assertValidEmail, assertRequiredField } from '@/client/utils'
import { requiredFields } from './form'

export const assertFields = (name, value, assertText) => {
  if (name === 'Company') {
    return value.length < 3 ? assertText.company_assert_text : ''
  }

  if (name === 'Email') {
    return assertValidEmail(value, assertText.email_assert_text)
  }

  if (requiredFields.includes(name)) {
    return assertRequiredField(value, assertText.normal_assert_text)
  }

  return ''
}
